export const PHONE_ERROR_MESSAGE = "Неправильний номер телефону";
